// import React from "react";
// import Graph from "../Graph/Graph";
// import "./Opportunity.css";
// import { useSelector } from "react-redux";

// const OpportunityChart = ({ title, data, dataKey, badgeColor, gradientId }) => (
//   <div className="opportunity-chart">
//     <h3 className="chart-header">{title}</h3>
//     {data && data.length > 0 ? (
//       <Graph
//         data={data}
//         dataKey={dataKey}
//         color={badgeColor}
//         gradientId={gradientId}
//         height="60%"
//         style={{ marginTop: "20px", marginLeft: "-35px" }}
//       />
//     ) : (
//       <p className="no-data-message">No data available</p> // Graceful fallback
//     )}
//   </div>
// );

// const Opportunity = () => {
//   const data = useSelector((state) => state?.agentHome?.performanceData); // Safely access performanceData

//   return (
//     <div>
//       <div className="opportunity-charts">
//         <div className="opportunity-container">
//           <OpportunityChart
//             title="First Call Resolution"
//             data={data?.firstCallResolution} // Optional chaining
//             dataKey="value"
//             badgeColor="#ff4757"
//             gradientId="firstCallResolutionGradient"
//           />
//           <div className="chart-legend-opportunity">
//             <div className="legend-item-opportunity">
//               <div className="opportunity-legend-dot optimal"></div>
//               <span>First Call Resolution</span>
//             </div>
//             <div className="legend-item-opportunity">
//               <div className="opportunity-legend-dot median"></div>
//               <span>Median Performance</span>
//             </div>
//           </div>
//         </div>
//         <div className="opportunity-container">
//           <OpportunityChart
//             title="Calls Put On Hold"
//             data={data?.callsOnHold} // Optional chaining
//             dataKey="value"
//             badgeColor="#4CAF50"
//             gradientId="callsOnHoldGradient"
//           />
//           <div className="chart-legend-opportunity">
//             <div className="legend-item-opportunity">
//               <div className="opportunity-legend-dot optimal"></div>
//               <span>Calls Put On Hold</span>
//             </div>
//             <div className="legend-item-opportunity">
//               <div className="opportunity-legend-dot median"></div>
//               <span>Median Performance</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Opportunity;

import React from "react";
import Graph from "../Graph/Graph";
import "./Opportunity.css";
import { useSelector } from "react-redux";

const OpportunityChart = ({
  title,
  data,
  dataKey,
  badgeColor,
  gradientId,
  yAxisProps = {}, // Additional Y-axis props
  medianValue, // Add medianValue prop
}) => {
  // Log the dataKey to the console
  // console.log("dataKey:", data[0].totalCalls);

  return (
    <div className="opportunity-chart">
      <h3 className="chart-header">{title}</h3>
      <Graph
        data={
          data?.result?.length > 0
            ? data.result
            : [{ range: "No Data", [dataKey]: 0 }]
        }
        dataKey={dataKey}
        color={badgeColor}
        gradientId={gradientId}
        width="107%"
        height="60%"
        style={{ marginTop: "20px", marginLeft: "-35px" }}
        yAxisProps={yAxisProps}
        medianValue={medianValue}
      />
      {data?.result?.length === 0 && (
        <p className="no-data-message">No data available</p>
      )}
    </div>
  );
};

const Opportunity = () => {
  const data = useSelector((state) => state?.agentHome?.performanceData); // Safely access performanceData
  console.log(data);
  const FCRMedianValue = data?.medians?.FCR;
  const CallPutOnHoldMedianValue = data?.medians?.callsPutOnHold;
  console.log(FCRMedianValue);

  return (
    <div>
      <div className="opportunity-charts">
        <div className="opportunity-container">
          <OpportunityChart
            title="First Call Resolution"
            data={data}
            dataKey="FCR"
            badgeColor="#2196F3"
            gradientId="firstCallResolutionGradient"
            yAxisProps={{
              // dataKey: "totalCalls",
              domain: [
                0,
                100
              ],
              interval: 0,
              tickCount: 3,
            }}
            medianValue={FCRMedianValue}
          />
          <div className="chart-legend-opportunity">
            <div className="legend-item-opportunity">
              <div className="opportunity-legend-dot optimal"></div>
              <span>First Call Resolution (in %)</span>
            </div>
            <div className="legend-item-opportunity">
              <div className="opportunity-legend-dot median"></div>
              <span>Average Performance</span>
            </div>
          </div>
        </div>
        <div className="opportunity-container">
          <OpportunityChart
            title="Calls Put On Hold"
            data={data}
            dataKey="callsPutOnHold"
            badgeColor="#2196F3"
            gradientId="callsOnHoldGradient"
            yAxisProps={{
              // dataKey: "totalCalls",
              domain: [
                0,
                //                 Math.round(
                //   Math.max(
                //     CallPutOnHoldMedianValue || 0,
                //     ...(data?.result?.map((item) => item.callsPutOnHold || 0) ||
                //       [])
                //   )
                // ),

                100
              ],
              interval: 0,
              tickCount: 3,
            }}
            medianValue={CallPutOnHoldMedianValue}
          />
          <div className="chart-legend-opportunity">
            <div className="legend-item-opportunity">
              <div className="opportunity-legend-dot optimal"></div>
              <span>Calls Put On Hold (in %)</span>
            </div>
            <div className="legend-item-opportunity">
              <div className="opportunity-legend-dot median"></div>
              <span>Average Performance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Opportunity;
